<script>
  import {ServiceMenu} from "@util/constant.js"
  import LargeMenuItem from "./LargeMenuItem.svelte"

</script>


<div class="spacing:bottom:40">
  <LargeMenuItem Menu={ServiceMenu} ColumnNumber={3} />
</div>
<div class="block:center">
  <a href="/service/" class="owd-button owd-button:large owd-button:secondary:white">サービス一覧はこちら</a>
</div>
